import { render, staticRenderFns } from "./darkMode.vue?vue&type=template&id=0511df94&"
import script from "./darkMode.vue?vue&type=script&lang=js&"
export * from "./darkMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports